<ng-template #loading>
   <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>

<ng-template #emptylist>
   <div>No Address Book Entries</div>
</ng-template>

<ng-template #noresults>
   <div>No Matching Address Book Entries</div>
</ng-template>

<ng-container *ngIf="ab$ | async as list; else loading">
   <div class="addressbook">
      <div class="ab-sidebar" *ngIf="!(breakpoints.small && entryOutlet.isActivated)">
         <div class="alpha-list">
            <span *ngFor="let alpha of AlphaMap | keyvalue" [class.active]="alpha.value" (click)="_vpLoaded.getValue().scrollToIndex( alpha.value )">{{alpha.key}}</span>
         </div>

         <cdk-virtual-scroll-viewport itemSize="60" class="ab-list">
            <div class="ab-tab" routerLinkActive="active" routerLink="/addressbook/new" color="primary">
               <span class="common-flex common-aicenter">
                  <mat-icon>add</mat-icon> Add New
               </span>
            </div>

            <div class="ab-tab" *ngFor="let entry of list; let i = index" #rla="routerLinkActive"
            routerLinkActive="active" routerLink="/addressbook/edit/{{entry.id}}" color="primary" (click)="listClick()">
               {{entry.name}}
               <mat-icon *ngIf="rla.isActive">chevron_right</mat-icon>
            </div>
         </cdk-virtual-scroll-viewport>
      </div>

      <div class="entry">
         <router-outlet #entryOutlet="outlet"></router-outlet>
      </div>
   </div>
</ng-container>
